<template>
  <div :class="routerName.name=='home'?'homepage':'otherpage'">
    <div :class="(routerName.name=='home' && brheight>100)?'scorllheight':'header'">
      <div class="toplogo"><router-link to="/"><img v-if="(routerName.name=='home' && brheight<=100 )" src="@/assets/logo.png"/><img v-else src="@/assets/logo_black.png"/></router-link></div>
      <nav>
        <el-menu
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-sub-menu index="2">
          <template #title>产品</template>
          <el-menu-item index="/product/chenggui">城轨</el-menu-item>
          <el-menu-item index="/product/railway">铁路</el-menu-item>
          <el-menu-item index="/product/lowaltitude">低空</el-menu-item>
          <el-menu-item index="/product/emergencyresponse">应急</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="3">
          <template #title>服务</template>
          <el-menu-item index="/service/Train">培训</el-menu-item>
          <el-menu-item index="/service/Competition">竞赛</el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/join/joinUs">加入我们</el-menu-item>
        <el-menu-item index="/case/CasePage">案例</el-menu-item>
      </el-menu>
      </nav>
   </div>
   <div class="container" id="myElement">
      <div v-if="routerName.name!='home'" class="content">
        <router-view/>
      </div>
      <router-view v-else/>
   </div>
   <el-backtop target=".container" :right="brwidth>1200?100:30" :bottom="brwidth>1200?100:50" />
</div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import router from '@/router'; 
    const routerName = ref(router.currentRoute)
    const brwidth = ref(0)
    const brheight = ref(0)
    const handleSelect = (key: string, keyPath: string[]) => {
      router.push(keyPath && keyPath[keyPath.length-1])
      // console.log(key, keyPath,keyPath)
    }
    // 监听浏览器窗口宽度变化
    function handleResize() {
      brwidth.value = window.innerWidth;
    }
    // 监听浏览器滚动条高度变化
    function handlepageYOffset() {
      var element = document.getElementById('myElement');
      brheight.value  = element.scrollTop;
    }
    window.addEventListener("scroll", handlepageYOffset, true)
    window.addEventListener('resize', handleResize);
    onMounted(()=>{
        handleResize()
      
      handlepageYOffset()
    })
</script>
<style lang="less" scoped>
#app {
  text-align: center;
  color: #2c3e50;
}

.homepage{
  width:100%;
  height:100vh;
  .header{
    position: fixed;
    width: 100%;
    height: 60px;
    z-index: 999;
    box-shadow: none;
    -webkit-transition: all 1s ease 0s;
    nav{
      .el-menu{
        background:none;
        .el-menu-item{
          color:#fff;
          font-size:18px;
        }
        .el-menu-item:hover{
          background:none;
          color:#CD4A26;
        }
        .is-active{
          background:none;
          color:#CD4A26 !important;
          border-bottom:none;
        }
        :deep(.el-sub-menu .el-sub-menu__title:hover){
          background:none;
        }
        :deep(.is-active .el-sub-menu__title) {
          background:none;
          color:#CD4A26 !important;
          border-bottom:none;
        }
        :deep(.el-sub-menu__title){
          color:#fff;
          font-size:18px;
        }
      }
    }
  }
  .scorllheight{
    position: fixed;
    width: 100%;
    height: 60px;
    z-index: 999;
    background:#fff;
    -webkit-transition: all 1s ease 0s;
    nav{
      .el-menu{
        .el-menu-item{
          font-size:18px;
        }
        
        .el-menu-item:hover{
          background:none;
          color:#CD4A26;
        }
        :deep(.el-sub-menu .el-sub-menu__title:hover){
          color:#CD4A26;
        }
        .is-active{
          background:none;
          color:#CD4A26 !important;
          border-bottom:none;
        }
        :deep(.is-active .el-sub-menu__title) {
          background:none;
          color:#CD4A26 !important;
          border-bottom:none;
        }
        :deep(.el-sub-menu__title){
          font-size:18px;
        }
      }
    }
  }
  .container{
    height:100vh;
    width: 100%;
    overflow-y:auto; 
  }
}
.otherpage{
  width:100%;
  height:100vh;
  background: url("@/assets/content_bg.png") no-repeat;
  background-size: cover;
  overflow-y: hidden;

  .header{
    width: 100%;
    height: 60px;
    box-shadow: 0 5px 5px #ededed;
    z-index: 999;
    position: relative;
    .el-menu{
      .el-menu-item{
        font-size:18px;
      }
      
      .el-menu-item:hover{
        background:none;
        color:#CD4A26;
      }
      :deep(.el-sub-menu .el-sub-menu__title:hover){
        color:#CD4A26;
      }
      .is-active{
        background:none;
        color:#CD4A26 !important;
        border-bottom:none;
      }
      :deep(.is-active .el-sub-menu__title) {
        background:none;
        color:#CD4A26 !important;
        border-bottom:none;
      }
      :deep(.el-sub-menu__title){
        font-size:18px;
      }
    }
  }
  .container{
    height:calc(100vh - 60px);
    width: 100%;
    overflow-y:scroll;
    
  }
}

.toplogo{
    position: absolute;
    margin-left:50px;
}
.toplogo img{
    height:40px;
    margin:10px;
}
nav {
  width:60%;
  margin:0 auto;
  
  .el-menu{
    justify-content: space-evenly;
    border-bottom:0px solid transparent;
  }
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.content{
  width:1200px;
  margin:0 auto;
  left:50%;
  margin-left:-600px;
  float:left;
  position: relative;
  margin-bottom: 50px;
}
:deep(.carousel1){
  display:block;
}
:deep(.carousel2){
    display:block;
  }
:deep(.certificate_mobile){
  display:none;
}
// 平板样式
@media screen and (min-width: 769px) and (max-width: 1200px) {
  nav {
      width: 70% !important;
      float:right;
      .el-menu{
        width:auto !important;
        background-color: transparent !important;
      }
      :deep(.el-sub-menu__hide-arrow .el-sub-menu__icon-arrow){
        display:inline-block !important;
      }
      :deep(.el-menu--horizontal>.el-sub-menu.is-active .el-sub-menu__title){
        border-bottom:none !important;
      }
    }
    .toplogo{
      margin-left: 10px !important;
    }
    .container{
      overflow-y:auto !important;
    }
  .content{
    width: 92%;
    margin: 0 4%;
    left: 0;
    float: left;
    position: relative;
    margin-bottom: 50px;
    :deep(.aboutus){
      .detailpic{
        img{
          width:100%
        }
      }
    }
  }
}

// 手机样式
@media (max-width: 768px) {
  nav {
    width: 100px !important;
    float:right;
    .el-menu{
      width:50px !important;
      background-color: transparent !important;
    }
    :deep(.el-sub-menu__hide-arrow .el-sub-menu__icon-arrow){
      display:inline-block !important;
      
    }
    :deep(.el-menu--horizontal>.el-sub-menu.is-active .el-sub-menu__title){
        border-bottom:none !important;
    }
  }
  .toplogo{
    margin-left: 10px !important;
  }
  :deep(.slogan){
    margin-top:65% !important;
    h3{
      font-size:36px !important;
    }
    span{
      font-size:26px !important;
    }
  }
  .container{
    overflow-y:auto !important;
  }
  .content{
    width: 92%;
    margin: 0 4%;
    left: 0;
    float: left;
    position: relative;
    margin-bottom: 50px;
    :deep(.detailpic){
      flex-direction: column !important;
      div{
        width: 100%  !important;
        padding:0 !important;
      }
      img{
        width: 100%  !important;
        padding:0 !important;
        margin-top:20px !important;
      }
    }
    :deep(.dikong){
      .dkdetail{
        margin-top:40px !important;
      }
      .detailpic{
        margin-top:0 !important;
      }
    }

    :deep(.jspic){
      flex-direction: column !important;
      >div{
        width: 100%  !important;
        padding:0 !important;
        margin:0 !important;
        margin-top:10px !important;
      }
      img{
        width: 100%  !important;
        padding:0 !important;
      }
    }
    :deep(.fuwupic){
      flex-direction: column !important;
      .fuwupicitem{
        width: 100%  !important;
        padding:0 !important;
        margin-top:10px !important;
      }
      img{
        width: 100%  !important;
        padding:0 !important;
      }
    }

    :deep(.casepic){
      flex-direction: column !important;
      >div{
        width: 100%  !important;
        padding:0 !important;
        margin:0 !important;
        margin-top:20px !important;
      }
      img{
        width: 100%  !important;
        padding:0 !important;
      }
    }
    
    :deep(.kydetail){
        flex-direction: column !important;
        .kyitem{
          width: 100%  !important;
          padding:0 !important;
          margin-bottom:20px;
        }
    }
    :deep(.jddetail){
      flex-direction: column !important;
      .youjiantou{
        display:none;
      }
      .jditem{
        width: 100%  !important;
        padding:0 !important;
      }
    }
    :deep(.case-one){
      .article{
        text-align:left !important;
      }
    }
    :deep(.siji .kyitem){
        padding-top: 0 !important;
    }
    :deep(.siji .kyitem img){
        margin-top: 0 !important;
    }
    :deep(.dkmodule1 ){
      >div{
        margin:0 0 20px 0 !important;
      }
    }
    :deep(.moduleinfo){
      span{
        width:24% !important;
      }
    }
    :deep(.moduleinfo2){
      span{
        width:32% !important;
      }
    }
    :deep(.tongxin){
      .detailpic{
        >div{
          margin-bottom:20px;
          img{
            margin-top:0!important;
          }
        }
      }
    }
    :deep(.gongdian){
      .detailpic{
        >div{
          margin-bottom:20px;
          img{
            margin-top:0!important;
          }
        }
      }
    }
    :deep(.dongche){
      .detailpic{
        >div{
          margin-bottom:20px;
          img{
            margin-top:0!important;
          }
        }
      }
    }
    :deep(.dianwu){
      .detailpic{
        >div{
          img{
            margin-top:0!important;
          }
        }
      }
    }
    :deep(.tongxinzhuanye){
      .detailpic{
        >div{
          img{
            margin-top:0!important;
          }
        }
      }
    }

  }
  :deep(.contact_us_cont){
    flex-direction: column;
  }
  :deep(.carousel1){
    display:none;
  }
  :deep(.carousel2){
    display:none;
  }
  :deep(.certificate_mobile){
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .detailpic{
      width: 49% !important;
      float: left;
      margin-top: 20px;
      span{
        text-align:center;
        display:block;
        margin-top: 10px;
      }
    }
  }
}
</style>
